module.exports = __webpack_public_path__ + "static/media/97.1da2aa06.jpg";